import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchIncident = createAsyncThunk(
  "incident/fetchIncident",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${server}/alldata_of_incident_mongodb`,
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );
      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData;
      } else {
        console.error("Unexpected API Response Format:", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching incident details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const incidentSlice = createSlice({
  name: "incident",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncident.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchIncident.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchIncident.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default incidentSlice.reducer;
